import React from 'react';
import { useNavigate } from 'react-router-dom';
import { PlusIcon } from 'lucide-react';
import { Avatar } from './Avatar';
import { findPerson } from '../data/people';
import { useLocale } from '../contexts/LocaleContext';
import { useSocial } from '../contexts/SocialContext';
import type { PulseRing } from '../types';

/**
 * Beelyv Pulse is presented as progress capsules with gold/green status rings,
 * not as circular story bubbles.
 */
export function PulseRail({
  pulses
}: {
  pulses: PulseRing[];
}) {
  const {
    t,
    tl
  } = useLocale();
  const navigate = useNavigate();
  const social = useSocial();
  const ownPulse = pulses.find(ring => ring.authorId === 'me');
  const others = pulses.filter(ring => ring.authorId !== 'me');
  return <ul className="bee-rail -mx-2 flex gap-2 overflow-x-auto px-2 pb-1" data-id="element-1293" data-mp="2scobuxfblc3s">
      {!ownPulse && <li className="shrink-0" data-id="element-1294" data-mp="t1n844ynpse6">
          <button type="button" onClick={() => navigate('/novo/pulse')} className="flex h-[104px] w-[74px] flex-col items-center justify-center gap-1 rounded-[16px] border border-dashed border-deep/30 bg-white/60 transition-colors duration-150 ease-brand hover:border-gold" data-id="element-1295" data-mp="xz6w3wl5pjjb">
            <span className="grid h-8 w-8 place-items-center rounded-pill bg-deep text-gold" data-id="element-1296" data-mp="1sdyjacpv4reh">
              <PlusIcon size={16} data-id="element-1297" data-mp="1nfx2jyfwt466" />
            </span>
            <span className="text-[10px] font-medium text-deep" data-id="element-1298" data-mp="1nh83zrlvtzu4">
              {t('pulse.create')}
            </span>
          </button>
        </li>}

      {[...(ownPulse ? [ownPulse] : []), ...others].map(ring => {
      const author = findPerson(ring.authorId);
      const first = ring.items[0];
      return <li key={ring.id} className="shrink-0" data-id="element-1299" data-mp="26652k7obbei5">
            <button type="button" onClick={() => {
          social.markPulseSeen(ring.id);
          navigate(`/pulse/${ring.id}`);
        }} aria-label={`${t('pulse.open')} — ${author.name}`} className={`relative block h-[104px] w-[74px] overflow-hidden rounded-[16px] text-left transition-transform duration-150 ease-brand active:scale-[0.98] ${ring.seen ? 'ring-1 ring-sand-line' : 'ring-2 ring-gold ring-offset-1 ring-offset-sand'}`} data-id="element-1300" data-mp="265d50rb5n6p8">
              <img src={first.media} alt="" aria-hidden="true" className={`absolute inset-0 h-full w-full object-cover ${ring.seen ? 'opacity-65' : ''}`} data-id="element-1301" data-mp="s4yzakexo8y2" />
              <span className="absolute inset-0 bg-deep/55" aria-hidden="true" data-id="element-1302" data-mp="4h8vt0ba8blh" />
              <span className="absolute left-1 top-1" data-id="element-1303" data-mp="8j3zgbgor12f">
                <Avatar src={author.avatar} name={author.name} size={22} data-id="element-1304" data-mp="3qo78u8dopz8n" />
              </span>
              <span className="absolute bottom-1 left-1 right-1" data-id="element-1305" data-mp="3vmqus8sa3b10">
                <span className="block truncate text-[9.5px] font-bold text-sand" data-id="element-1306" data-mp="3vm8sovixq2l6">
                  {author.id === 'me' ? t('pulse.mine') : author.name.split(' ')[0]}
                </span>
                <span className="block truncate text-[8.5px] text-sand/80" data-id="element-1307" data-mp="373yk6bl75ovj">
                  {tl(first.label)}
                </span>
              </span>
              {ring.items.length > 1 && <span className="bee-num absolute right-1 top-1 rounded-pill bg-deep/80 px-1 text-[8.5px] font-bold text-gold" data-id="element-1308" data-mp="3gz08x6bk8oxl">
                  {ring.items.length}
                </span>}
            </button>
          </li>;
    })}
    </ul>;
}